import React from 'react'
import styles from './SelectionTools.scss'
import cx from 'classnames'
import { CTA } from 'common/styleguide/CTA'
import { icons } from '../icons'
import { FormattedMessage as T, defineMessages } from 'react-intl'
import { useFormatMessage } from 'lib/localization'

export const messages = defineMessages({
  selectionTools: {
    id: 'RouteTools.selectionTools',
    defaultMessage: 'Selection Tools'
  },
  deleteSelection: {
    id: 'SelectionTools.deleteSelection',
    defaultMessage: 'Delete Selection'
  },
  flattenElevation: {
    id: 'SelectionTools.flattenElevation',
    defaultMessage: 'Flatten Elevation'
  },
  changeColor: {
    id: 'SelectionTools.changeColor',
    defaultMessage: 'Change Color'
  },
  remCtrlPoints: {
    id: 'SelectionTools.remCtrlPoints',
    defaultMessage: 'Remove Control Points'
  },
  exclFromMetrics: {
    id: 'SelectionTools.exclFromMetrics',
    defaultMessage: 'Exclude from Metrics'
  },
  crop: {
    id: 'SelectionTools.crop',
    defaultMessage: 'Crop'
  }
})

export const SelectionTools = ({
  needsUpgrade, selection, closeSelectionTools, performAction
}) => {
  const fm = useFormatMessage()

  return <div className={styles.SelectionTools}>
    <div className={styles.title}>{fm(messages.selectionTools)}</div>
    <div style={{ margin: '0 10px' }}>
      <div className={cx(styles.boxes, styles.routeTools)}>
        <div title={fm(messages.deleteSelection)} onClick={() => performAction('deleteSelection')} className={cx(needsUpgrade && styles.needsUpgrade)}>
          {icons.deleteSelection}
          <div>{fm(messages.deleteSelection)}</div>
        </div>
        <div title={fm(messages.flattenElevation)} onClick={() => performAction('flattenElevation')} className={cx(needsUpgrade && styles.needsUpgrade)}>
          {icons.flattenElevation}
          <div>{fm(messages.flattenElevation)}</div>
        </div>
        <div title={fm(messages.changeColor)} onClick={() => performAction('changeColor')} className={cx(needsUpgrade && styles.needsUpgrade)}>
          {icons.changeColor}
          <div>{fm(messages.changeColor)}</div>
        </div>
        <div title={fm(messages.remCtrlPoints)} onClick={() => performAction('removeControlPoints')} className={cx(needsUpgrade && styles.needsUpgrade)}>
          {icons.removeControlPoints}
          <div>{fm(messages.remCtrlPoints)}</div>
        </div>
        <div title={fm(messages.exclFromMetrics)} onClick={() => performAction('excludeFromMetrics')} className={cx(needsUpgrade && styles.needsUpgrade)}>
          {icons.excludeFromMetrics}
          <div>{fm(messages.exclFromMetrics)}</div>
        </div>
        <div title={fm(messages.crop)} onClick={() => performAction('crop')} className={cx(needsUpgrade && styles.needsUpgrade)}>
          {icons.crop}
          <div>{fm(messages.crop)}</div>
        </div>
      </div>
      {!selection && <CTA style={{ backgroundColor: '#ea6d2c' }} onClick={closeSelectionTools}>&lt; <T id='SelectionTools.backToRouteTools' defaultMessage='Back to Route Tools' /></CTA>}
      {selection && <CTA style={{ backgroundColor: '#ea6d2c' }} onClick={closeSelectionTools}><T id='SelectionTools.deselect' defaultMessage='Deselect' /></CTA>}
    </div>
  </div>
}
